const SET_VISITED_UNITS = 'set-visited-units';

export { SET_VISITED_UNITS };
